import { connect } from 'react-redux';

import { destroy, getFormValues } from 'redux-form';

import i18n from 'shared/lib/i18n';

import LeasingComponent from './LeasingComponent';

import { submitLeasingMessage } from './utils';

const validate = (values) => {
  const errors = {};
  if (!values.email && !values.phoneNumber) {
    errors.email = i18n.t('errors.emailOrPhoneRequired');
    errors.phoneNumber = i18n.t('errors.emailOrPhoneRequired');
  }
  return errors;
};

const form = 'Leasing';

const mapStateToProps = (state, ownProps) => {
  const leasingOfficeNotes = ownProps?.building?.leasingNote;
  const initialValues = { notes: leasingOfficeNotes };
  const formValues = getFormValues(form)(state);
  const notes = formValues?.notes;

  return {
    form,
    initialValues,
    validate,
    notes,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (data) => {
    const { notes, ...rest } = data;
    const { building, setIsLeasingShown } = ownProps;
    submitLeasingMessage(dispatch, building?.id, rest);
    setIsLeasingShown(false);
    dispatch(destroy(form));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LeasingComponent);
